import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router'

import { Image, Text, Button, Skeleton } from '@betty/moonlight';

import {
  RewardNamesMapDesktop,
  RewardNamesMapMob,
} from './EarnRewardsSection.constants';
import styles from './EarnRewardsSection.module.css';
import {
  fetchPromo,
  selectLandingPromoByType,
  selectLandingPromosDataState,
} from '@betty/auth';
import { useDispatch } from '@betty/toolkit/state';
import { Breakpoint, useBreakpoint } from '@betty/moonlight';

function EarnRewardsSection() {
  const dispatch = useDispatch();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const navigate = useNavigate();
  const welcomePromo = useSelector(selectLandingPromoByType('Welcome'));
  const welcomePromoDataState = useSelector(selectLandingPromosDataState);

  useEffect(() => {
    if (welcomePromoDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, welcomePromoDataState]);

  const imageName = useMemo(() => {
    const rewards = welcomePromo?.rewards;
    if (!rewards || rewards.length === 0) return;

    const isSingleReward = rewards.length === 1;
    const rewardTarget = rewards[0]?.rewardTarget;

    if (isSingleReward) {
      return isMobile
        ? RewardNamesMapMob[rewardTarget]
        : RewardNamesMapDesktop[rewardTarget];
    }

    return isMobile ? 'rewardsWheelMob' : 'rewardsWheelDesktop';
  }, [isMobile, welcomePromo]);

  return (
    <div className={styles.earnRewardsSection}>
      <div className={styles.imageContainer}>
        {welcomePromoDataState.match('idle|pending') ? (
          <Skeleton
            width={{
              desktop: '100%',
              tablet: '100%',
              mobile: 265,
            }}
            height={{
              desktop: 150,
              tablet: 150,
              mobile: 80,
            }}
            margin={{
              desktop: 'space-400',
              tablet: undefined,
              mobile: undefined,
            }}
            borderRadius='radius-200'
          />
        ) : imageName ? (
          <Image
            name={`landingPage.${imageName}`}
            width={{
              desktop: '100%',
              tablet: '100%',
              mobile: 265,
            }}
            height={{
              desktop: '100%',
              tablet: '100%',
              mobile: 80,
            }}
            aspectRatio={{
              desktop: '21/9',
              tablet: '21/9',
              mobile: undefined,
            }}
          />
        ) : null}
      </div>
      <div className={styles.labelContainer}>
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          textAlign={{
            desktop: 'left',
            tablet: 'left',
            mobile: 'center',
          }}
        >
          Earn rewards to play one of our most exciting games!
        </Text>
        {welcomePromo?.subTypeMeta?.minimumQualificationAmount ? (
          <Text variant="body-s" color="darkSurfacePrimary">
            With a first deposit of $
            {welcomePromo?.subTypeMeta?.minimumQualificationAmount} or more!
          </Text>
        ) : null}
        <Button
          variant="primary"
          onPress={() => navigate('/register')}
          rightIcon="arrowForward"
          locKey="Play now"
        />
      </div>
    </div>
  );
}

export default EarnRewardsSection;
